import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { WarningAmberRounded as WarnIcon } from "@mui/icons-material";
import { HOL, holGhostBtnSx, holPrimaryBtnSx } from "../../../UserSide/pages/holTheme";
import { holDangerBtnSx } from "./holHostUi";

const HolConfirmDialog = ({
  open,
  title,
  children,
  confirmLabel,
  onConfirm,
  cancelLabel = "Cancel",
  onCancel,
  tone = "danger",
  busy = false,
  footer = null,
}) => (
  <Dialog
    open={!!open}
    onClose={busy ? undefined : onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: "20px",
        background: "linear-gradient(165deg, #1b1b1f 0%, #111114 100%)",
        border: `1px solid ${tone === "danger" ? "rgba(255,90,90,0.35)" : HOL.panelBorder}`,
        boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
      },
    }}
  >
    <DialogContent sx={{ pt: 3.5, pb: 1, textAlign: "center" }}>
      <Box
        sx={{
          width: 56,
          height: 56,
          mx: "auto",
          mb: 2,
          borderRadius: "50%",
          display: "grid",
          placeItems: "center",
          bgcolor: tone === "danger" ? "rgba(255,90,90,0.14)" : "rgba(245,215,110,0.14)",
          color: tone === "danger" ? "#ff7070" : HOL.gold,
        }}
      >
        <WarnIcon sx={{ fontSize: 30 }} />
      </Box>
      <Typography sx={{ fontFamily: HOL.fontDisplay, fontWeight: 900, fontSize: "1.45rem", mb: 1 }}>
        {title}
      </Typography>
      <Box sx={{ color: "rgba(255,255,255,0.75)", fontSize: "0.95rem", lineHeight: 1.55 }}>{children}</Box>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: footer ? 1 : 3, pt: 2, gap: 1, justifyContent: "center", flexWrap: "wrap" }}>
      <Button variant="outlined" onClick={onCancel} disabled={busy} autoFocus sx={{ ...holGhostBtnSx, px: 3, py: 1 }}>
        {cancelLabel}
      </Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={busy}
        startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
        sx={tone === "danger" ? { ...holDangerBtnSx, py: 1 } : { ...holPrimaryBtnSx, minHeight: 0, py: 1 }}
      >
        {confirmLabel}
      </Button>
    </DialogActions>
    {footer ? <Box sx={{ px: 3, pb: 2.5, textAlign: "center" }}>{footer}</Box> : null}
  </Dialog>
);

export default HolConfirmDialog;
